<template lang="pug">
    div.sessionInfo
        v-layout(raw wrap)
            v-flex.text-md-center(xs12 md2)

                // Instructor Name
                title-component(
                    type="h4"
                    slot="title"
                    v-if="session.instructor && session.instructor.fullName"
                    :title="$t('fields.instructor')"
                )

                div.instructor(v-if="session.instructor && session.instructor.fullName")

                    // Instructor Avatar
                    div.instructorImage(v-if="session.instructor && session.instructor.avatar")
                        img(:src="session.instructor.avatar")

                    // Instructor Avatar stub
                    div.instructorImageStub(v-else) {{ session.instructor.fullName | fullNameInitials}}

                    // Instructor name
                    div.instructorFullName
                        span {{ session.instructor.fullName | formattedFullName }}

            v-flex(xs12 md10)
                div.sessionDescription
                    // Title Description
                    title-component(
                        type="h4"
                        slot="title"
                        :title="$t('fields.sessionDescription')"
                    )

                    // Meditation Description
                    div {{ session.description }}
</template>

<script>
    import VueTypes from 'vue-types';
    import Title from '~components/Title';
    import formattedFullName from '~filters/FormattedFullName';
    import fullNameInitials from '~filters/FullNameInitials';

    export default {
        components: {
            TitleComponent: Title
        },
        props: {
            session: VueTypes.object.default({})
        },
        filters: {
            formattedFullName,
            fullNameInitials
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'
    @import "../../../../assets/style/_mixins.styl"

    .sessionInfo
        padding: 20px
        background: rgba(255, 255, 255, 0.1);
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);

    .instructor
          display: flex
          flex-direction: column
          align-items: center

    .instructorImageStub
    .instructorImage img
        width: 47px
        height: 47px
        border-radius: 47px
        margin-right: 10px

    .instructorImageStub
        background-color: $theme.white
        opacity: 0.5
        color: $theme.primary
        text-align: center
        font-size: 27px
        line-height: 47px
        font-weight: 700

    .instructorFullName
        margin-top: 8px;
        font-size: 12px

    .sessionDescription
        height: 100%
        padding-left: 40px
        border-left: 1px solid rgba($theme.grey, 0.5)

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .sessionInfo
            padding: 20px 10px

        .instructor
            display: flex
            flex-direction: row
            align-items: center

        .instructorFullName
            margin-top: 0;
            font-size: 12px

        .sessionDescription
            border-left-width: 0
            padding-left: 0
            margin-top: 20px
</style>
